<template>
  <footer class="footer-auth">
    <div class="mx-5">
      <div class="row text-center">
        <div class="col-lg-4">
          <a href="https://facebook.com">
            <img src="@/assets/images/fb.png" width="25" class="mx-2" />
          </a>
          <a href="https://twitter.com">
            <img src="@/assets/images/twitter.png" width="25" class="mx-2" />
          </a>
          <a href="https://instagram.com">
            <img src="@/assets/images/ig.png" width="25" class="mx-2" />
          </a>
          <a href="https://linkedin.com">
            <img src="@/assets/images/linkedin.png" width="25" class="mx-2" />
          </a>
        </div>
        <div class="col-lg-4">
          Copyright © 2022 AEX. All Rights Reserved
        </div>
        <div class="col-lg-4">
          <a :href="`${webUrl}/syarat-ketentuan`" target="_blank" class="text-decoration-none">Syarat dan Ketentuan</a>
          |
          <a :href="`${webUrl}/kebijakan-privasi`" target="_blank" class="text-decoration-none">Kebijakan Privasi</a>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>
export default {
  data() {
    return {
      webUrl: process.env.VUE_APP_BASE_URL_WEB
    }
  }
}
</script>